











import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class News extends Vue {
    @Prop(Array) value!: {title: string; body: string; date: string}[];
}
